module.exports = __webpack_public_path__ + "cf59a26850c27d7c750c3deaf0ef5788.svg";